<template>
  <div class="drive-detail">
    <div class="drive-detail-wrapper">
      <div class="zlxc-container" style="overflow: visible">
        <!-- 面包屑 -->
        <div class="bread-crumbs">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>学驾服务</el-breadcrumb-item>
            <el-breadcrumb-item>驾校风采</el-breadcrumb-item>
            <el-breadcrumb-item>驾校详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 驾校区域 -->
        <div class="driving-demeanor" v-if="dataSheetDetail">
          <div class="demeanor">
            <div class="school-node">
              <div class="node-img">
                <img class="driving-img" :src="dataSheetDetail.iconUrl" />
              </div>
              <div class="node-info">
                <div class="info-title">{{ dataSheetDetail.schoolName }}</div>
                <div class="info-score">
                  <el-rate
                    class="score-rate"
                    :value="dataSheetDetail.starLevel"
                    disabled
                    text-color="#ff9900"
                  ></el-rate>
                  <p class="score-nub">{{ dataSheetDetail.starLevel }}分</p>
                </div>
                <div class="info-address">
                  <img
                    class="address-icon"
                    src="../../assets/zlxcimgs/home_icon_location@2x.png"
                  />
                  <p class="address-text">
                    {{ dataSheetDetail.address }}
                  </p>
                </div>
                <div class="info-phone">
                  <img
                    class="phone-icon"
                    src="../../assets/zlxcimgs/home_icon_tell@2x.png"
                  />
                  <p class="phone-text">{{dataSheetDetail.commonPhone ? dataSheetDetail.commonPhone : dataSheetDetail.contactPhone}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="demeanor-btn">报名咨询</div>
        </div>
        <!-- 驾校详情 -->
        <div class="driving-detail">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="驾校简介" name="introduction">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">驾校简介</p>
              </div>
              <div class="pane-substance">
                <p class="sub-text">{{dataSheetDetail.introduce ? dataSheetDetail.introduce : ''}}</p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="场地" name="space">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">场地</p>
              </div>
              <div
                class="pane-imgs"
                v-for="(item, index) in dataSpaceList"
                :key="index + new Date().getTime()"
              >
                <div class="imgs-context">
                  <img class="driving-img" :src="item" />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="教练员" name="coach">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">教练员</p>
              </div>
              <div class="pane-demeanor-list" v-if="coachList">
                <div class="pane-demeanor" v-for="item in coachList" :key="item.coachId">
                  <div class="node-img">
                    <img
                      class="driving-img"
                      :src="item.image"
                    />
                  </div>
                  <div class="node-info">
                    <div class="info-title">{{item.coachName}}</div>
                    <div class="info-score">
                      <el-rate
                        class="score-rate"
                        :value="item.starLevel"
                        disabled
                        text-color="#ff9900"
                      ></el-rate>
                      <p class="score-nub">{{item.starLevel}}分</p>
                    </div>
                    <div class="info-address">
                      <p class="address-text">
                        所属驾校：{{ dataSheetDetail.schoolName }}
                      </p>
                    </div>
                    <div class="info-phone">
                      <p class="phone-text">准教车型：{{item.driveModel}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="教练车" name="coachcar">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">教练车</p>
              </div>
              <div class="pane-imgs">
                <div class="imgs-context">
                  <img
                    class="driving-img"
                    src="../../assets/zlxcimgs/second_icon_zhaopian@2x.png"
                  />
                </div>
                <div class="imgs-context">
                  <img
                    class="driving-img"
                    src="../../assets/zlxcimgs/second_icon_zhaopian@2x.png"
                  />
                </div>
                <div class="imgs-context">
                  <img
                    class="driving-img"
                    src="../../assets/zlxcimgs/second_icon_zhaopian@2x.png"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="班型" name="classtype">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">班型</p>
              </div>
              <div class="pane-table">
                <el-table :data="tableData" border style="width: 100%">
                  <el-table-column prop="classModel" label="驾照类型" width="180">
                  </el-table-column>
                  <el-table-column prop="className" label="班型" width="180">
                  </el-table-column>
                  <el-table-column prop="totalPrice" label="学车总金额 (元)">
                  </el-table-column>
                  <el-table-column prop="remark" label="班型介绍">
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="报名地址" name="registration">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">报名地址</p>
              </div>
              <div class="pane-address">
                <img
                  class="address-icon"
                  src="../../assets/zlxcimgs/home_icon_location@2x.png"
                />
                <p class="address-text">{{ dataSheetDetail.address }}</p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="报名咨询" name="advisory">
              <div class="pane-title">
                <p class="title-circle"></p>
                <p class="title-text">报名咨询</p>
              </div>
              <div class="pane-phone">
                <img
                  class="phone-icon"
                  src="../../assets/zlxcimgs/home_icon_tell@2x.png"
                />
                <p class="phone-text">{{ dataSheetDetail.commonPhone ? dataSheetDetail.commonPhone : dataSheetDetail.contactPhone }}</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryGetSchoolDetailById,
  queryGetSiteBySchoolId,
  queryQueryList,
  queryTrainingClasss
} from "@/api/herbalMedicine";
import { formatTime } from "@/utils/common.js";

export default {
  name: "DriveDetail",
  data() {
    return {
      activeName: "introduction",
      tableData: [
        {
          license: "C1",
          name: "C1普通班",
          amount: "¥4600",
          introduce: "C1 普通班，时间自由，周一到周五全天练车",
        },
        {
          license: "C1",
          name: "C1普通班",
          amount: "¥4600",
          introduce: "C1 普通班，时间自由，周一到周五全天练车",
        },
        {
          license: "C1",
          name: "C1普通班",
          amount: "¥4600",
          introduce: "C1 普通班，时间自由，周一到周五全天练车",
        },
        {
          license: "C1",
          name: "C1普通班",
          amount: "¥4600",
          introduce: "C1 普通班，时间自由，周一到周五全天练车",
        },
        {
          license: "C1",
          name: "C1普通班",
          amount: "¥4600",
          introduce: "C1 普通班，时间自由，周一到周五全天练车",
        },
      ],
      // 驾校详情
      dataSheetDetail: null,
      // 场地图片列表
      dataSpaceList: [],
      // 驾校教练列表
      coachList: [],
    };
  },
  created() {
    // 官网驾校信息
    this.getQueryGetSchoolDetailById();
  },
  methods: {
    handleClick(tab, event) {
      let curTab = tab.name;
      if (curTab == "space") {
        this.getQueryGetSiteBySchoolId();
      } else if (curTab == "coach") {
        this.getQueryQueryList();
      } else if (curTab == "classtype") {
        this.getQueryTrainingClasss();
      }
    },
    // 官网驾校信息
    getQueryGetSchoolDetailById() {
      queryGetSchoolDetailById({
        schoolId: this.$route.query.id,
      }).then((res) => {
        this.dataSheetDetail = res.data;

        for (var item of this.dataSheetDetail) {
           item.starLevel = parseFloat(item.starLevel);
        }
      });
    },
    // 查询驾校场地图片列表
    getQueryGetSiteBySchoolId() {
      queryGetSiteBySchoolId({
        schoolId: this.$route.query.id,
      }).then((res) => {
        this.dataSpaceList = res.data;
      });
    },
    // 查询驾校教练员详情
    getQueryQueryList() {
      queryQueryList({
        trainingSchoolId: this.$route.query.id,
      }).then((res) => {
        this.coachList = res.data;
      });
    },
    // 根据驾校查询班型列表
    getQueryTrainingClasss() {
      queryTrainingClasss({
        schoolId: this.$route.query.id,
      }).then((res) => {
        this.tableData = res.data;

        for (var item of this.tableData ) {
            item.totalPrice = (item.totalPrice/100).toFixed(2);
        }
        
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>